import React from "react";
import { Menu } from "@mui/icons-material";
import { AppBar, Toolbar, Typography, Grid, IconButton, Box } from "@mui/material";
import MainToolbar from "components-base/ToolBar";
import { Link } from "react-router-dom";

const MainAppBar = React.forwardRef(
  ({ classes, open, handleDrawerOpen, ...rest }, ref) => {
    const { onOpenSidenav, brandText } = rest;
    return (
      <AppBar
        enableColorOnDark
        sx={
          open
            ? {
                ...classes.appBar,
                ...classes.appBarShift,
                boxShadow: "none",
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "background.paper"
                    : "primary.main",
              }
            : {
                ...classes.appBar,
                boxShadow: "none",
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "background.paper"
                    : "primary.main",
              }
        }
        position="fixed"
      >
        <Toolbar>
          <Grid container direction="row">
            <Grid item xs={6}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item className="flex flex-row items-center gap-4 p-1">
                  <>
                    {!open && (
                      <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        sx={
                          open
                            ? { ...classes.menuButton, ...classes.hide }
                            : classes.menuButton
                        }
                      >
                        <Menu />
                      </IconButton>
                    )}
                    <div className="ml-[10px]" style={{ marginTop: "10px" }}>
                      <Link to="#" style={{ textDecoration: "none" }}>
                        <Typography
                          variant="h4"
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 700,
                            fontSize: { xs: "1.3rem", md: "1.6rem" },
                            letterSpacing: "0.06em",
                            textTransform: "capitalize",
                            background:
                              "linear-gradient(135deg, #ffffff 0%, #fce7f3 60%, #fbcfe8 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                            filter: "drop-shadow(0 2px 8px rgba(255,255,255,0.3))",
                            lineHeight: 1.1,
                          }}
                        >
                          {brandText || "Boopsi"}
                        </Typography>
                        <Box
                          sx={{
                            height: "2px",
                            width: "60%",
                            borderRadius: "2px",
                            mt: "3px",
                            background:
                              "linear-gradient(90deg, rgba(255,255,255,0.8) 0%, rgba(251,207,232,0.5) 60%, transparent 100%)",
                          }}
                        />
                      </Link>
                    </div>
                  </>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Grid item className="flex flex-row items-center gap-4 p-1">
                  <>
                    <MainToolbar
                      onOpenSidenav={onOpenSidenav}
                      brandText={brandText}
                    />
                  </>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
);

export default MainAppBar;
